import { Store } from 'redux';

import { QueryString } from '../../common/react/QueryString';
import { DisplayMode } from '../../ts/ServerApi/types/ISessionInfo';
import { updateExplorerDisplayMode } from '../actions/DisplaySettingsActions';
import { AppState } from '../state/AppState';
import { DisplaySettingsScope } from './DisplaySettingsReduxBindings';

export const DisplayModeUrlKey = 'mode';

/**
 * Unlike content filters, the URL is not the source of truth for display settings. However, URL
 * flags can dictate the display settings' initial values, and changes in the URL can trigger
 * updates to the display settings. Since we don't yet have an elegant system in React/Redux to
 * watch the URL and dispatch the relevant actions, those watchers are set up here.
 *
 * The watchers defined in this class will still be necessary even after we remove all the Angular
 * code that uses "displaySettings" (or until this class is ported away from Angular).
 */
export function bindDisplaySettingsScopeToUrlAndSetInitialValues(
    $scope: DisplaySettingsScope,
    store: Store<AppState>,
    queryString: QueryString
): void {

  setDisplayModeFromUrlIfParamIsPresent(queryString, store);

  $scope.$on('$locationChangeSuccess', () => {
    setDisplayModeFromUrlIfParamIsPresent(queryString, store);
  });
}

function setDisplayModeFromUrlIfParamIsPresent(queryString: QueryString, store: Store<AppState>) {
  const displayModeFromUrlOrUndefined = getDisplayModeFromUrl(queryString);

  if (displayModeFromUrlOrUndefined) {
    // The URL flag is considered a browser-local override for test automation only,
    // so we don't save that setting to the server
    store.dispatch(updateExplorerDisplayMode(displayModeFromUrlOrUndefined, false));
  }
}

function getDisplayModeFromUrl(queryString: QueryString): DisplayMode | undefined {
  const urlParams = queryString();
  const displayModeFromUrl = urlParams[DisplayModeUrlKey];

  switch (displayModeFromUrl) {
    case 'list':
    case 'thumbnail':
      return displayModeFromUrl;
    default:
      return undefined;
  }
}
